import { BuyerDetailsSection } from "./sections/buyer-details.section";

export const BuyerDetailsPage = ({ customerType = "registered" }) => <BuyerDetailsSection customerType={customerType} />;
